import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const navItems = [{
    label: 'Home',
    path: '/'
  }, {
    label: 'About',
    path: '/about'
  }, {
    label: 'Services',
    path: '/services'
  }, {
    label: 'Sectors',
    path: '/sectors'
  }, {
    label: 'Contact',
    path: '/contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-dark/95 backdrop-blur-md border-b border-slate-800/50' : 'bg-transparent'}`} data-id="element-128">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-129">
        <div className="flex items-center justify-between" data-id="element-130">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-id="element-131">
            <div className="w-12 h-12 bg-gold rounded-md flex items-center justify-center" data-id="element-132">
              <span className="text-navy-dark text-xl font-bold" data-id="element-133">888</span>
            </div>
            <div className="flex flex-col leading-tight" data-id="element-134">
              <span className="text-white text-sm font-semibold tracking-wide" data-id="element-135">
                SOURCING
              </span>
              <span className="text-white text-sm font-semibold tracking-wide" data-id="element-136">
                LIMITED
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-137">
            {navItems.map(item => <Link key={item.path} to={item.path} className={`text-sm font-medium transition-colors ${location.pathname === item.path ? 'text-gold' : 'text-slate-300 hover:text-white'}`} data-id="element-138">
                {item.label}
              </Link>)}
          </nav>

          {/* CTA Button */}
          <Link to="/supplier-registration" className="hidden lg:block bg-gold hover:bg-gold-dark text-navy-dark px-6 py-2.5 rounded-md font-semibold text-sm transition-colors" data-id="element-139">
            Register as Supplier
          </Link>

          {/* Mobile Menu Button */}
          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-white p-2" aria-label="Toggle menu" data-id="element-140">
            {isMobileMenuOpen ? <XIcon size={24} data-id="element-141" /> : <MenuIcon size={24} data-id="element-142" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="lg:hidden mt-4 pb-4 border-t border-slate-800 pt-4" data-id="element-143">
            <nav className="flex flex-col gap-4" data-id="element-144">
              {navItems.map(item => <Link key={item.path} to={item.path} className={`text-sm font-medium transition-colors ${location.pathname === item.path ? 'text-gold' : 'text-slate-300 hover:text-white'}`} data-id="element-145">
                  {item.label}
                </Link>)}
              <Link to="/supplier-registration" className="bg-gold hover:bg-gold-dark text-navy-dark px-6 py-2.5 rounded-md font-semibold text-sm transition-colors w-full mt-2 text-center" data-id="element-146">
                Register as Supplier
              </Link>
            </nav>
          </div>}
      </div>
    </header>;
}